// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"93de5b98","752":"bad42f00"}[chunkId] + ".chunk.js";
};